import WRAP from "WRAP-JS";
import ViewExt from "./WRAP.Geo/ViewExt";

/* eslint-disable */
WRAP.Geo.switchMap = function (view) {
  return new Promise(resolve => {
    if ( this.view == view ) {
      this.view.invalidate();
      resolve(this.view);
      return;
    }
    var zoom, center;
    zoom = WRAP.Geo.getZoom();
    center = WRAP.Geo.getCenterPoint();

    var layers = this.view.layers;
    var tooltipGroup = this.view._tooltipGroup;
    var min_zoom = this.view.min_zoom;
    var max_zoom = this.view.max_zoom;

    this.view.layers = [];
    this.view._tooltipGroup = [];
    this.view.invalidate();

    var cr = this.view.context.revision;

    var map = WRAP.Map.get(this.view);
    if ( !map )
      map = WRAP.Map.init(view);
    else
      map.setView(view);

    this.selectView(view);
    view.setZoomRange(min_zoom, max_zoom);

    view._tooltipGroup = tooltipGroup;
    view.context.revision = ++cr;
    view.setLayer(layers);
    if ( !isNaN(zoom) && zoom >= 0 && center && (center.lat != 0 || center.lon != 0))  {
      view.ready(function() {
        WRAP.Geo.setZoom(zoom);
        WRAP.Geo.setCenterPoint(center);
        view.refresh();
        view.invalidate();
        resolve(view);
      });
    }
    view.refresh();
  });
};

WRAP.Geo.disposeView = function(type, instance) {
  const vts = this.views[type];
  if (!vts) {
    return;
  }
  const newVts = vts.reduce((accumulator, vt) => {
    const view = vt.view;
    if (view === instance) {
      view.clear();
      if (view.map && view.map.clear) {
        view.map.clear()
      }
    } else {
      accumulator.push(vt);
    }
    return accumulator;
  }, []);

  if (newVts.length === 0) {
    delete this.views[type];
  } else {
    this.views[type] = newVts;
  }
};

WRAP.Geo.waitLayerDraw = function (func, duration, timeout, layers, ignoreError= false) {
  this.view.waitLayerDraw(func, duration, timeout, layers, ignoreError);
};

WRAP.Geo.registView = function (type, instance, bridge) {
  var vt = this.views[type];
  if ( !vt )
    vt = this.views[type] = [];
  for ( var i = 0 ; i < vt.length ; i++ ) {
    if ( vt[i].instance == instance )
      return vt[i].view;
  }
  var map = bridge(instance);
  var view = new ViewExt(++this.view_count);
  view.setMap(map);
  var v = {
    instance: instance,
    map: map,
    view: view
  }
  vt.push(v);
  if ( !this.view )
    this.view = view;
  if ( this.event_store ) {
    for ( var i = 0 ; i < this.event_store.length ; i++ ) {
      var e = this.event_store[i];
      view.addEventHandler(e[0], e[1]);
    }
  }
  return view;
};

WRAP.Geo.addAnimation = function(a) {
  var self = this;
  this.animations.push(a);

  var current = new Date();
  if ( !this.animation_timer ) {
    this.animation_start = current;
    // this.animation_timer = setInterval(function() {
    (async function animateFrame(){
      var current = new Date();
      var elapsed = (current-self.animation_start)/1000;
      for ( var i = 0 ; i < self.animations.length ; i++ ) {
        await self.animations[i]._go(elapsed);
      }
      if (self.animations.length) {
        window.requestAnimationFrame(animateFrame);
      }
    })()
  }
  return (current - this.animation_start)/1000;
}

WRAP.Geo.TimeController = function () {
  this._layers = [];
  var self = this;
  /**
   * 現在の表示時間を設定する
   * @method setDisplayTime
   * @param  {WRAP.Core.DateTime} time 時間
   * @param  {Function} cb フレーム描画完了コールバック
   * @param  {Number} timeout フレーム描画完了監視タイムアウト（秒）
   * @return  なし
   **/
  this.setDisplayTime = function(time, cb, timeout, silent) {
    self._current_time = time;
    // console.log(`||| setDisplayTime ${time}`)
    for ( var i = 0 ; i < self._layers.length ; i++ ) {
      var layer = self._layers[i];
      if ( !layer.visible() )
        continue;
      layer.set(layer.get()||{}, true, silent);
    }
    if ( cb ) {
      WRAP.Geo.waitLayerDraw(function(status) {
        // console.log(`||| ★★★ ${time} complete:${status.completed.length} error:${status.error.length} incomplete:${status.incompleted.length} :${status.elapsed}`);
        status.time = time
        cb(status);},
        0.1,
        timeout||WRAP.Geo.defaultFrameTimeout,
        self._layers);
    }
  }

  /**
   * 現在の表示時間を返す
   * @method displayTime
   * @param  なし
   * @return {WRAP.Core.DateTime} 時間
   **/
  this.displayTime = function() {
    return self._current_time;
  }

  /**
   * 時間管理を行うレイヤーを登録する
   * 登録されたレイヤーに対する、時間設定（set）は TimeControllerが実行する
   * @method addLayer
   * @param  {WRAP.Geo.Layer} layer レイヤー
   * @return {Object} なし
   **/
  this.addLayer = function(layer) {
    if ( self._layers.indexOf(layer) < 0 ) {
      layer.setTimeController(this);
      self._layers.push(layer);
    }
    this.setDisplayTime(self._current_time);
  }

  /**
   * レイヤーを時間管理対象から削除する
   * @method removeLayer
   * @param  {WRAP.Geo.Layer} layer レイヤー
   * @return {Object} なし
   **/
  this.removeLayer = function(layer) {
    var index = self._layers.indexOf(layer);
    if ( index >= 0 ) {
      self._layers[index].setTimeController(null);
      self._layers.splice(index, 1);
    }
  }

  this.validate = function(layer, content) {
    //console.log("validate:"+layer.name());
    if ( !content )
      return false;
    if ( self._current_time && layer._data ) {

      if ( layer._data.validator ) // custom content validator
        return (layer._data.validator(self._current_time, layer._data, content));

      var data = layer._data;
      var validtime;
      var timelist = (data.retained&&data.retained.timelist&&data.retained.timelist.timelist)
        || (data.query&&data.query("timelist").value());
      if ( timelist && content.basetime ) {
        for ( var i = 0 ; i < timelist.length ; i++ ) {
          if ( timelist[i].basetime == content.basetime ) {
            validtime = timelist[i].validtime;
            //console.log("basetime:"+content.basetime);
            break;
          }
        }
      }
      else {
        validtime = (data.retained&&data.retained.validtime&&data.retained.validtime.validtime)
          || (data.query&&data.query("validtime").value());
        //console.log("validtime list ="+(validtime?validtime.length:"---"));
      }
      if ( validtime ) {
        validtime = validtime.concat();
        validtime.sort(
          function(a,b){
            if( a < b ) return -1;
            if( a > b ) return 1;
            return 0;
          });
        var dt = WRAP.DH._time(self._current_time);
        var diff = 24*3600;
        for ( var i = 0 ; i < validtime.length ; i++ ) {
          var vt = WRAP.DH._time(validtime[i]);
          var nt = (i<validtime.length-1)?WRAP.DH._time(validtime[i+1]):WRAP.DH._setTime(vt,diff);
          if ( vt <= dt && dt < nt ) {
            content.validtime = WRAP.DH._timeString(vt);
            //console.log("validtime ="+content.validtime);
            return true;
          }
          diff = WRAP.DH._elapsed(vt, nt);
        }
      }
    }
    //console.log("validtime not found");
    content.validtime = null;
    return false;
  }
};

WRAP.Geo.Animation = function() {

  this._timeout = WRAP.Geo.defaultFrameTimeout;

  /**
   * アニメーションの各フレームの描画完了の最大待機時間を指定する
   *
   * @method setTimeout
   * @param {Number} duration タイムアウト（秒）
   * @return なし
   **/
  this.setTimeout = function(duration) {
    this._timeout = duration;
  }

  /**
   * アニメーションの各フレームの属性キー配列とアニメーションフレームのインターバル時間を設定する
   * 属性キーは basetime、validtimeなどを含む WRAP.Geo.Later.set関数で指定する属性オブジェクトと同等のもので
   * 具体的な形式はデータに依存し各データの論理構造定義で定められる
   *
   *          属性キーの例）
   *          {
   *              basetime：{String},
   *              validtime：{String}
   *          }
   *
   * @method setTimeRange
   * @param {Array} time_list [{Object}, ...] フレームの属性キー配列
   * @param {Number} interval アニメーション・インターバル時間
   * @return なし
   **/
  this.setTimeRange = function(time_array, interval) {
    this._frame = time_array;
    this._interval = parseFloat(interval);
    this._last_time = 0;
    this._next_time = 0;
    this._current = -1;
    this._time = 0;

    this._running = null;
    this._cb = null;
  }

  /**
   * アニメーションの各フレームのvalidtimeの範囲とアニメーションフレームのインターバル時間を設定する
   * @method setValidTimeRange
   * @param {String} start_time アニメーション開始フレームの Validtime
   * @param {String} end_time アニメーション終了フレームの Validtime
   * @param {Integer} step アニメーション各フレームの Validtimeの間隔
   * @param {Number} interval アニメーション・インターバル時間（秒で指定）
   * @return 設定された Validtimeのリスト
   *          [
   *          　　{
   *             　　 validtime：{String}
   *          　　}, ...
   *          ]
   **/
  this.setValidTimeRange = function(start_time, end_time, step, interval) {
    var time_array = [{validtime:start_time}];
    var st = WRAP.DH._time(start_time);
    var et = WRAP.DH._time(end_time);
    var ct = WRAP.DH._setTime(st, step);
    while ( ct < et ) {
      time_array.push({validtime:WRAP.DH._timeString(ct)});
      ct = WRAP.DH._setTime(ct, step);
    }
    if ( st < et )
      time_array.push({validtime:end_time});

    this._frame = time_array;
    this._interval = parseFloat(interval);
    this._last_time = 0;
    this._next_time = 0;
    this._current = -1;
    this._time = 0;

    this._running = null;
    this._cb = null;
    return time_array;
  }

  /**
   * アニメーションコントローラにレイヤーを結びつける
   *
   * フレームの属性キーを共有できる複数のレイヤーを一つのアニメーションコントローラに登録することができる
   *
   * @method setLayer
   * @param {Array} layer_list [{WRAP.Gei.Layer}, ...] レイヤー配列
   * @return なし
   **/
  this.setLayer = function(layer_array) {
    this._layer = layer_array;
  }

  /**
   * アニメーションコントローラにタイムコントローラを結びつける
   *
   * @method setTimeController
   * @param {WRAP.Geo.TimeController} controller タイムコントローラ
   * @return なし
   **/
  this.setTimeController = function(controller) {
    this._controller = controller;
  }

  /**
   * 現在の表示フレームを指定した時間に合わせる
   * @method setTime
   * @param {Object} key 属性キー(時間構造に対応した形式)
   *
   *     {
   *          basetime:"20160831T000000",
   *          valietime:"20160831T120000"
   *     }
   * @return {}
   **/
  this.setTime = function(time) {
    this._running = false;
    var index = 0;
    while ( index < this._frame.length ) {
      if ( !time.basetime || time.basetime == this._frame[index].basetime )
        if ( time.validtime <= this._frame[index].validtime )
          break;
      index++;
    }
    //console.log("setTime index="+index);
    this._setFrame(index);
  }

  /**
   * フレーム変化直前に呼び出されるコールバック関数を設定する
   * @param {Function} function フレーム変化直前に呼び出されるコールバック関数
   */
  this.setUpdating = function (cb) {
    this._updatingCb = cb;
  }
  /**
   * アニメーションを開始する
   * フレームが変わる毎に指定した関数がコールバックされる
   * @method start
   * @param {Function} function フレーム変化時に呼び出されるコールバック関数
   *
   * コールバックの引数
   * + {Object} time（時間）属性キー
   * @return なし
   **/
  this.start = function(cb) {
    this._cb = cb;
    if ( !this._running ) {
      this._running = true;
      this._current_time = WRAP.Geo.addAnimation(this);
      var interval = this._preloading?0:this._interval;
      this._next_time = this._current_time+interval;
    }
    // console.log(`||| start current: ${this._current}`)
    this._update(true);
  }

  /**
   * アニメーションを停止する
   * @method stop
   * @param  なし
   * @return  なし
   **/
  this.stop = function() {
    this._running = false;

    // reset silent mode
    if ( this._layer ) {
      for ( var i = 0 ; i < this._layer.length ; i++ )
        this._layer[i].set(this._frame[this._current]);
    }
    if ( this._controller ) {
      this._controller.setDisplayTime(this._frame[this._current].validtime);
    }

    WRAP.Geo.removeAnimation(this);
    if ( this._preloading )
      this._endPreload();
  }

  /**
   * 現在の表示フレームの（時間）属性キーを返す
   * @method time
   * @param なし
   * @return {Object} 属性キーオブジェクト
   **/
  this.time = function() {
    return this._time;
  }

  /**
   * アニメーションフレームを事前ロードする
   * @method preload
   * @param {Function} function フレームプリロード完了時に呼び出されるコールバック関数
   *
   * コールバックの引数
   * + {Integer} current_frame プリロード完了済みフレーム数
   * + {Integer} total_frame 全体フレーム数
   * @return なし
   **/
  this.preload = function(cb) {
    this._preloading = {
      save_index:this._current,
      count:0,
      total:this._frame.length,
      cb:cb
    }
    this._setFrame(0);
    this.start();
  }

  this._endPreload = function() {
    if ( this._preloading ) {
      if ( this._controller ) {
        var index = this._preloading.save_index;
        if ( index >= 0 )
          this._controller.setDisplayTime(this._frame[index].validtime);
      }
      this._preloading = undefined;
    }
  }

  this._update = function(status) {
    // console.log('||| _update!!!!');
    if ( !this._running ) {
      // console.log('||| already stopped');
      return;
    }
    if ( !this._preloading ) {
      // load next frame in silent mode
      var self = this;
      var current_status = status;
      var next_index = this._current+1;
      if ( next_index < this._frame.length ) {
        var next_time = this._frame[next_index].validtime;
        // console.log("preload index="+next_index+" time="+JSON.stringify(this._frame[next_index]));
        if ( this._layer ) {
          for ( var i = 0 ; i < this._layer.length ; i++ ) {
            if ( this._layer[i].visible() )
              this._layer[i].set(next_time, false, true);
          }
          WRAP.Geo.waitLayerDraw(function() {
            self._updated = current_status;
            //console.log("layer preload completed:"+next_index)
          }, 0.1, this._timeout);
        }
        if ( this._controller ) {
          // console.log(`||| preload call setDisplayTime ${next_time}`);
          this._controller.setDisplayTime(next_time,
            function() {
              // console.log(`||| preload setDisplayTime ${next_time} complete!!!!`);
              self._updated = current_status;
            }, this._timeout, true );
        }
        if ( !this._layer && !this._controller ) {
          self._updated = current_status;
        }
      }
      else {
        this._updated = status;
      }
    }
    else {
      this._updated = status;
      if ( this._preloading.cb ) {
        this._preloading.count = this._current+1;
        this._preloading.cb(this._preloading.count, this._preloading.total);
        if ( this._preloading.count == this._preloading.total )
          this._endPreload();
      }
    }
  }

  this._setFrame = function(index) {
    // console.log(`||| _setFrame: index:${index} time:${this._frame[index]?.validtime}`)
    var animation = this;
    this._updated = null;
    // console.log("setFrame index="+index);
    if ( !this._frame || !this._frame.length ) {
      this._time = undefined;
      this._current = -1;
      return false;
    }
    if ( index < 0 )
      index = 0;
    if ( index >= this._frame.length )
      index = this._frame.length-1;
    if ( this._current != index ) {
      this._current = index;
      this._time = this._frame[index];
      // console.log("index="+index+" time="+JSON.stringify(this._frame[index]));
      if (this._updatingCb) {
        this._updatingCb(this._frame[index].validtime);
      }
      if ( this._layer ) {
        for ( var i = 0 ; i < this._layer.length ; i++ ) {
          this._layer[i].set(this._frame[index], false, this._preloading);
        }
        WRAP.Geo.waitLayerDraw(function(status) {
          animation._update(status);
        }, 0.1, this._timeout);
      }
      if ( this._controller ) {
        this._controller.setDisplayTime(this._frame[index].validtime,
          function(status) {
            // console.log(`||| setDisplayTime callback ${this._frame[index].validtime}`)
            animation._update(status);
          }.bind(this), this._timeout, this._preloading );
      }
      if ( !this._layer && !this._controller ) {
        animation._update(true);
      }
      return true;
    }
    return false;
  }

  this._go = async function(time) {
    // console.log(`||| _go next_time: ${this._next_time} time: ${time} judge: ${this._next_time <= time}`)
    if ( !this._running )
      return;
    if ( this._next_time <= time ) {
      if ( !this._updated ) {
        // console.log('||| not updated...')
        return;
      }
      var interval = this._preloading?0:this._interval;
      this._next_time = time + interval;
      if ( this._setFrame(this._current+1) ) {
        if ( this._cb ) {
          await this._cb(this._time);
        }
      }
      if ( this._current >= this._frame.length-1 ) {
        // console.log('||| stop because running to the end.')
        this._running = false;
        WRAP.Geo.removeAnimation(this);
      }
    }
  }
}

WRAP.Geo.getTextMetricsAccurate = function(text, font_size) {
  if ( this.view && this.view.context )
      return this.view.context.textMetricsAccurate(text, font_size);
}
WRAP.Geo.parseColor = function(color) {
  if ( !this.color_cvs ) {
    this.color_cvs = document.createElement('canvas');
    this.color_cvs.width = 1, this.color_cvs.height = 1;
    this.color_ctx = this.color_cvs.getContext('2d', { willReadFrequently: true });
  }
  this.color_ctx.clearRect(0,0,1,1);
  this.color_ctx.fillStyle = color;
  this.color_ctx.fillRect(0,0,1,1);
  return this.color_ctx.getImageData(0,0,1,1).data;
}
// WebGL化に伴いmag_filterを外部から指摘できるようにするため、上書き
WRAP.Geo.Feature.Tile = function(style, animation) {
  WRAP.Geo.Feature.Base.call(this, style, animation);
  this.type = function() {return 'Tile'};
  this.draw = function(context) {
    context.setAlpha(this.alpha===undefined?1.0:this.alpha);
    context.layer = this.layer;
    context.feature = this;
    var s = this.drawStyle(context);
    context.drawTile(s.tile, s.imageData, s.elevationData, s.transparent, s.min_filter, s.mag_filter);
    context.setAlpha(1.0);
  }
  this.seal = function(screen) {
    screen.drawTile(this);
  }
}
/* eslint-enable */
